import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconWashingMachine: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 2h16c.6 0 1 .4 1 1v18c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zm15 2H5v2h14V4zM5 8v12h14V8H5zm2 6c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5zm2 0c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
